import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'

export const AvailabilityWrapper = styled.div`
  margin-bottom: 15px;
`

export const AvailabilityMobileWrapper = styled.div`
  border-bottom: 1px solid ${Theme.colors.grey};
  padding: 10px 10px;
`
